import React from "react";
import PTEImpImg from "../assets/utility/pte_class_imp.jpg"

export default function WhyChoosePTECoaching() {
  return (
    <main className="mt-5 mx-20 px-2 sm:px-4">

      {/* Importance Section */}
      <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
        Importance of PTE Coaching Classes
      </h1>

      <div className="flex flex-col md:flex-row items-center gap-8 text-gray-700 text-base leading-relaxed">

        {/* Left Content */}
        <div className="md:w-1/2 space-y-6">

          <p className="text-justify">
            Preparing for the PTE exam requires more than basic English knowledge.
            Professional PTE Coaching Classes provide structured preparation,
            expert strategies, and consistent evaluation to help candidates
            achieve their desired scores.
          </p>

          <ul className="space-y-3 mx-6 list-disc">
            <li>
              <span className="font-semibold text-gray-900">Expert Guidance:</span>{" "}
              Understand exam patterns, scoring criteria, and task-specific strategies
              from experienced trainers.
            </li>

            <li>
              <span className="font-semibold text-gray-900">Structured Environment:</span>{" "}
              A disciplined schedule and competitive atmosphere improve focus,
              motivation, and consistency.
            </li>

            <li>
              <span className="font-semibold text-gray-900">Authentic Resources:</span>{" "}
              Access updated study materials aligned with the official PTE format.
            </li>

            <li>
              <span className="font-semibold text-gray-900">Personalized Mentorship:</span>{" "}
              Receive individual feedback to identify and improve weak areas.
            </li>

            <li>
              <span className="font-semibold text-gray-900">Regular Mock Tests:</span>{" "}
              Performance evaluation builds confidence and improves time management.
            </li>
          </ul>

          <p className="text-justify">
            With proper mentoring, practice, and evaluation, candidates can
            significantly enhance their Reading, Writing, Speaking, and Listening
            skills and maximize their PTE scores.
          </p>

        </div>

        {/* Right Image */}
        <div className="md:w-1/2 flex justify-center">
          <img
            src={PTEImpImg}
            alt="PTE Coaching Importance"
            className="w-full max-h-[350px] rounded-lg shadow-lg hover:scale-105 transition duration-300 object-cover"
          />
        </div>

      </div>


      {/* Why Choose Shivasya Section */}
      <h1 className="mt-10 text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
        Why Choose Shivasya for PTE Coaching?
      </h1>

      <div className="space-y-6 text-gray-700 text-base leading-relaxed">

        <p className="text-justify">
          Shivasya PTE Coaching in Ahmedabad is committed to delivering
          result-oriented training for students aiming to study, work,
          or migrate abroad. Our approach focuses on personalized learning,
          expert mentoring, and consistent practice.
        </p>

        <ul className="space-y-3 mx-6 list-disc">
          <li>
            <span className="font-semibold text-gray-900">
              Personalized Learning Plans:
            </span>{" "}
            Customized strategies based on your strengths and weaknesses.
          </li>

          <li>
            <span className="font-semibold text-gray-900">
              Experienced Faculty:
            </span>{" "}
            Trainers with proven success records in PTE preparation.
          </li>

          <li>
            <span className="font-semibold text-gray-900">
              Smart Classes & Free Resources:
            </span>{" "}
            Advanced teaching methods and updated practice materials.
          </li>

          <li>
            <span className="font-semibold text-gray-900">
              Demo Classes & Expert Support:
            </span>{" "}
            Clear doubts anytime and experience our teaching approach before enrollment.
          </li>

          <li>
            <span className="font-semibold text-gray-900">
              Results-Oriented Training:
            </span>{" "}
            Students consistently achieve their target scores with structured practice.
          </li>
        </ul>

        <p className="text-justify font-semibold text-gray-900">
          📞 Contact Shivasya Ahmedabad today to book your seat and begin your
          journey toward studying, working, or migrating abroad with confidence.
        </p>
      </div>

    </main>
  );
}